import DocumentWidgetModal from '../../../components/Common/Documents/DocumentWidgetModal'
import React, { Component, Fragment } from 'react'
import { Avatar, Card, Icon, Layout, List, Modal } from 'antd'
import moment from 'moment'
import Auth from '../../../modules/Authentication'
import FilesModal from '../../../components/Common/Documents/Modal/Files'
import IconText from '../../../elements/IconText'

const { Content } = Layout

class DocumentsWidget extends Component {
  auth = new Auth()

  AvatarIcon = (mime) => {
    try {
      const type = mime.split('/')[0]
      switch (type) {
        case 'image':
          return 'picture'
        case 'text':
          return 'file-text'
        case 'audio':
          return 'sound'
        case 'video':
          return 'video-camera'
        case 'application':
          return 'laptop'

        default:
          return 'user'
      }
    } catch (e) {
      return 'user'
    }
  }

  render() {
    const {
      showModal,
      editable,
      handleCancel,
      owner,
      file,
      category,
      visible,
      type,
      email,
      emailLabel,
      showFullListModal,
      upload,
    } = this.props

    const demoInfiniteContainer = {
      border: '1px solid #e8e8e8',
      borderRadius: '4px',
      overflow: 'auto',
      padding: '8px 24px',
      height: '300px',
      width: '100%',
    }

    const Widget = () => (
      <List
        style={demoInfiniteContainer}
        dataSource={this.props.files}
        renderItem={(item) => (
          <List.Item className={'documents-mini-item'} key={item._id}>
            <List.Item.Meta
              avatar={<Avatar shape="square" icon={this.AvatarIcon(item.mime)} />}
              title={
                <a onClick={() => this.props.handleOnRowClick(item)}>
                  <a>{item.name}</a>
                </a>
              }
              description={`${item.owner.code} : ${moment(item.timestamp).format('YYYY/M/D')}`}
            />
            <div>{item.category}</div>
          </List.Item>
        )}
      />
    )

    const UploadButton = () => (
      <a onClick={showModal} disabled={!editable}>
        <Icon type="file-add" theme="outlined" /> Upload Files
      </a>
    )

    return (
      <Fragment>
        <FilesModal
          key={file._key}
          owner={owner}
          file={file}
          type={type}
          editable={editable}
          category={category}
          email={email}
          emailLabel={emailLabel}
          visible={visible}
          handleCancel={handleCancel}
          allowUpload={upload}
        />
        <DocumentWidgetModal {...this.props} />
        <Content className={'documents-mini-item'}>
          <Card
            title={
              <a onClick={showFullListModal}>
                <IconText type={'file'} text={'Documents'} />
              </a>
            }
            style={{ marginTop: 24 }}
            extra={upload && <UploadButton />}
            bordered={false}>
            <Widget />
          </Card>
        </Content>
      </Fragment>
    )
  }
}

DocumentsWidget.propTypes = {}
DocumentsWidget.defaultProps = {}

export default DocumentsWidget
